var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-home"},[(_vm.getGameConsole === 'classic')?_c('TopSportsBar'):_vm._e(),(_vm.getGameConsole === 'classic')?_c('PreliveSection'):_vm._e(),(_vm.getGameConsole === 'american')?_c('PreliveSectionAmerican'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }